import { useTranslation } from "react-i18next"
import { PageHeader } from "../../../components/HeaderComponents"
import { requestFastActionExcuses } from "../../../requests/ticket_requests"
import { useContext, useEffect, useState } from "react"
import { ContentContext } from "../../../contexts/ContentContext"
import { devLog } from "../../../utils/loggerUtils"
import { RxPlusCircled } from "react-icons/rx"
import { CiEdit } from "react-icons/ci"
import { PermissionContext } from "../../../contexts/PermissionContexts"
import { darkAndLightThemeDefault } from "../../../components/ThemeComponents"
import { MdDelete, MdDone } from "react-icons/md"
import { IoCloseSharp } from "react-icons/io5"
import { useNavigate } from "react-router-dom"
import { requestDeleteFastActionExcuse, requestEditFastActionExcuse, requestNewFastActionExcuse } from "../../../requests/setup_requests"
import { pageLoadingActive } from "../../../components/Background"



export const ExcusesSetup = () => {

    const { t } = useTranslation('settings')
    const { openErrorModal } = useContext(ContentContext)
    const { hasPermission } = useContext(PermissionContext)

    const navigator = useNavigate()

    useEffect(() => {

        if (!hasPermission("setup:view")) {
            navigator("/admin/dashboard")
            return
        }
    }, [])

    const [fastActionExcuses, setFastActionExcuses] = useState(null)

    const [editInProgress, setEditInProgress] = useState(false);

    useEffect(() => {
        pageLoadingActive(true)
        requestFastActionExcuses({})
            .then((data) => {
                // setFastActionExcuses(data.fast_action_excuses)
                setFastActionExcuses((prev) => ({ ...data.fast_action_excuses }))
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
            .finally(() => {
                pageLoadingActive(false)
            })
    }, [])


    if (!hasPermission("setup:view")) {
        return <></>
    }

    return (
        <div className="flex flex-col w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600  rounded-md px-4 py-3 gap-3 min-h-[500px]">
            <PageHeader pageTitle={t("Excuses Setup")} />
            <span>{t('Set up the employee excuses.')}</span>


            <span className="text-lg font-semibold">{t("Fast action excuses")}</span>
            <div className="flex gap-5">

                <FastActions action="RESOLVED" fastActionExcuses={fastActionExcuses} setFastActionExcuses={setFastActionExcuses} editInProgress={editInProgress} setEditInProgress={setEditInProgress} />
                <FastActions action="CLOSED" fastActionExcuses={fastActionExcuses} setFastActionExcuses={setFastActionExcuses} editInProgress={editInProgress} setEditInProgress={setEditInProgress} />
            </div>


        </div>
    )
}


const FastActions = ({ action, fastActionExcuses, setFastActionExcuses, editInProgress, setEditInProgress }) => {
    const { t } = useTranslation(['settings', 'common'])

    const [openNew, setOpenNew] = useState(false);

    const handleOpenNew = () => {
        setOpenNew(true)
    }

    useEffect(() => {
        if (!editInProgress) {
            setOpenNew(false)
        }
    }, [editInProgress])

    return (
        <div className="flex flex-col gap-3">
            <span className="font-semibold">{t(action, { ns: "common" })}</span>
            <div className="flex flex-col gap- w-full lg:min-w-[360px] max-w-[400px] border rounded-lg py-2 border-gray-300 dark:border-gray-600 ">
                {
                    fastActionExcuses &&
                    fastActionExcuses[action].map((excuse, index) =>
                        <FastActionExcuse key={`${excuse} + ${index}`} prop={excuse} index={index} action={action} setFastActionExcuses={setFastActionExcuses} editInProgress={editInProgress} setEditInProgress={setEditInProgress} openNew={openNew} setOpenNew={setOpenNew} />
                    )
                }

                {
                    fastActionExcuses &&
                    fastActionExcuses[action].length === 0 &&
                    !openNew &&
                    <span className="text-center text-sm ltr:italic">{t("Create new excuse")}</span>
                }

                {
                    openNew &&
                    <FastActionExcuse prop="" index={null} action={action} setFastActionExcuses={setFastActionExcuses} editInProgress={editInProgress} setEditInProgress={setEditInProgress} openNew={openNew} setOpenNew={setOpenNew} />
                }

                <div className="flex w-full justify-center mt-4">
                    <button
                        className="btn w-full btn-md h-9 p-0 text-primary dark:text-blue-600 bg-white dark:bg-gray-700 hover:text-white hover:bg-primary  border-gray-500 dark:border-gray-500 hover:border-gray-300 dark:hover:border-gray-500"
                        disabled={editInProgress}
                        onClick={handleOpenNew}
                    >
                        <RxPlusCircled size={30} />
                    </button>
                </div>
            </div>

        </div>
    )
}


const FastActionExcuse = ({ prop, index, action, setFastActionExcuses, editInProgress, setEditInProgress, openNew, setOpenNew }) => {
    const { t } = useTranslation('settings')
    const { openErrorModal } = useContext(ContentContext)

    const [excuse, setExcuse] = useState(prop ? prop : "")

    const [edit, setEdit] = useState(false)

    const handleOpenEdit = () => {

        setEdit(true)
        setEditInProgress(true)
    }

    const handleSubmit = () => {
        if (openNew) {
            pageLoadingActive(true)
            requestNewFastActionExcuse({ action: action, excuse: excuse })
                .then((data) => {
                    setFastActionExcuses((prev) => ({ ...data.fast_action_excuses }))
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
                .finally(() => {
                    setOpenNew(false)
                    setEdit(false)
                    setEditInProgress(false)
                    pageLoadingActive(false)
                })
        }
        else {
            pageLoadingActive(true)
            requestEditFastActionExcuse({ action: action, prevExcuse: prop, newExcuse: excuse })
                .then((data) => {
                    setFastActionExcuses((prev) => ({ ...data.fast_action_excuses }))
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
                .finally(() => {
                    setEdit(false)
                    setEditInProgress(false)
                    pageLoadingActive(false)
                })
        }

    }

    const handleDelete = () => {
        pageLoadingActive(true)
        requestDeleteFastActionExcuse({ action: action, excuse: prop })
            .then((data) => {
                setFastActionExcuses((prev) => ({ ...data.fast_action_excuses }))
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
            .finally(() => {
                setEdit(false)
                setEditInProgress(false)
                pageLoadingActive(false)
            })
    }

    const handleClose = () => {
        setEdit(false)
        setEditInProgress(false)
    }

    useEffect(() => {
        if (index === null && prop === "") {
            handleOpenEdit()
        }
    }, [])


    return (
        !edit ?
            <div className="flex w-full gap-3 px-2 py-1 group items-center justify-between text-gray-800 dark:text-gray-300 bg-inherit hover:bg-gray-100 dark:hover:bg-gray-600">
                <span>{excuse}</span>
                <button
                    className="btn btn-sm w-8 opacity-0 group-hover:opacity-100 transition-all duration-300 disabled:invisible ease-in-out border-none bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-primary dark:hover:bg-blue-600 hover:text-white p-0"
                    disabled={editInProgress}
                    onClick={handleOpenEdit}
                >
                    <CiEdit size={24} />
                </button>
            </div>
            :
            <div className="flex w-full gap-3 px-2 items-center">
                <label className="form-control w-full">

                    <input
                        type="text"
                        placeholder={t('Title')}
                        className="input input-bordered input-md w-full h-10 p-1 px-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                        required={true}
                        value={excuse}
                        onChange={(e) => {
                            setExcuse(e.target.value);
                        }}
                    />
                </label>
                <div className="flex gap-1  ">

                    <button className="btn btn-sm w-8 h-8 p-0 bg-green-600 hover:bg-green-500 border-none text-white" onClick={handleSubmit}><MdDone size={18} /></button>
                    {!(index === null && prop === "")
                        &&
                        <button className="btn btn-sm w-8 h-8 p-0 bg-red-600 hover:bg-red-500 border-none text-white" onClick={handleDelete}><MdDelete size={18} /></button>
                    }
                    <button className={`btn btn-sm w-8 h-8 p-0 ${darkAndLightThemeDefault}`} onClick={handleClose}><IoCloseSharp size={18} /></button>
                </div>
            </div>
    )
}